import { extendTheme, Select, Textarea } from "@chakra-ui/react";
import colors from "./foundations/colors";
import fonts from "./foundations/fonts";
import typography from "./foundations/typography";
import Button from "./components/Button";
import InputTheme from "./components/Input";
import FormLabel from "./components/FormLabel";
import layerStyles from "./layerStyles";
import SelectTheme from "./components/SelectTheme";
import AutocompleteTheme from "./components/AutocompleteTheme";
import TextareaTheme from "./components/TextAreaTheme";

const theme = extendTheme({
  colors: {
    ...colors,
    background: colors.neutral.bgLight,
  },
  fonts,
  styles: {
    global: {
      body: {
        bg: "neutral.bgLight",
        color: "neutral.textPrimary",
      },
    },
  },
  textStyles: typography, // use textStyle="sectionLabel" etc
  layerStyles,
  components: {
    Autocomplete: AutocompleteTheme,
    Button,
    Input: InputTheme,
    Select: SelectTheme,
    FormLabel,
    Textarea: TextareaTheme,
  },
});

export default theme;
